/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import ThreeDotsLoader from '../../Components/LoadingDots';

function ApproveAndRejectModal({
    approveModal, setApproveModal, handleApproveRequest, returnReason, setReturnReason, threeDotsLoader, setThreeDotsLoader,
}) {
    return (
        <div className={`modal fade fixed top-0 left-0 ${approveModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="addDocumnetation" tabIndex="-1" aria-labelledby="addDocumnetation" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative lg:max-w-[443px] lg:min-w-[443px] w-full px-5 mx-auto pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white border border-[#707070] bg-clip-padding rounded-md outline-none text-current md:px-[30px] sm:px-4 px-3 sm:pt-[32px] pt-4 pb-5">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                        <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                            Approve Return Request
                        </h5>
                        <button
                            onClick={() => setApproveModal(false)}
                            type="button"
                            className="absolute top-0 right-0"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <img src="images/Icon-ionic-ios-close.svg" alt="" />
                        </button>
                    </div>
                    <div className="modal-body pt-[22px]">
                        <div className="relative pb-5">
                            <label htmlFor="inp" className="text-base font-semibold text-[#555259]">Are you sure you want to approve this return request?</label>
                            <textarea
                                name="enterMoremessage"
                                value={returnReason}
                                id="inp"
                                className="w-full h-[108px] resize-none px-[13px] py-[14px] border border-[#707070] rounded-lg mt-3 sm:text-base text-xs6 font-normal text-[#000000] placeholder:text-base placeholder:text-[#808285] placeholder:font-normal outline-none custom-scrollbar"
                                placeholder="Enter additional note(optional)"
                                onChange={(e) => { setReturnReason(e.target.value); }}
                            />
                            <p className="absolute bottom-[3px] right-5 px-1 bg-[#FFFFFF] text-xs13 font-normal text-[#808285]">500 words</p>
                        </div>
                        <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-[22px] rounded-b-md">
                            <button
                                type="button"
                                className="border border-[#555259] bg-[#FFFFFF] text-base font-normal text-[#555259] px-14 py-3 rounded-lg"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setApproveModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-16 rounded-lg"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => { handleApproveRequest(); }}
                            >
                                {threeDotsLoader ? <div><ThreeDotsLoader /></div> : 'Yes'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ApproveAndRejectModal;
